import type { SerializedError } from "@reduxjs/toolkit";
import type { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";

import type { RTKError } from "models/RTKError";

export function isRTKError(
  error?: FetchBaseQueryError | SerializedError
): error is RTKError {
  if (!error) {
    return false;
  }

  if (!("data" in error) || !error.data || typeof error.data !== "object") {
    return false;
  }

  if (
    !("exception" in error.data) ||
    !error.data.exception ||
    typeof error.data.exception !== "object"
  ) {
    return false;
  }

  return (
    "code" in error.data.exception &&
    "message" in error.data.exception &&
    typeof error.data.exception.code === "number" &&
    typeof error.data.exception.message === "string"
  );
}
